"use client";
import { useContext, useEffect, useState } from "react";
import { CartContext } from "@/context/CartContext";
import { Trash2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const RemoveFromCart = ({ data }) => {
  const { cart, getTotalPrice, removeFromCart } = useContext(CartContext);
  const [cartProducts, setCartProducts] = useState([]);
  const [cartTotalPrice, setCartTotalPrice] = useState(0);

  useEffect(() => {
    setCartProducts(cart);
    setCartTotalPrice(getTotalPrice());
  }, [cart, getTotalPrice]);

  const handleRemoveFromCart = (item) => {
    removeFromCart(item);

    const cartItems = cartProducts?.map((item) => ({
      item_id: item?._id,
      item_name: item?.title,
      item_brand: item?.brand || "",
      item_category: item?.category,
      item_subcategory: item?.subCategory,
      item_type: item?.type || item?.brand,
      item_variant: item?.variant || "",
      price: item?.discountedPrice,
      quantity: item?.quantity,
    }));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        value: cartTotalPrice,
        currency: "BDT",
        items: cartItems,
      },
    });
  };

  return (
    <Badge
      onClick={() => handleRemoveFromCart(data)}
      className="flex items-center gap-2 text-white bg-red-500 cursor-pointer shadow-brand-sm transition-colors"
    >
      <Trash2 size={14} className="text-white" />
      Remove
    </Badge>
  );
};

export default RemoveFromCart;